import { usePermissionStore } from '../stores/permissionStore'

/**
 * Check if user has permission on a resource+action.
 * Uses GET /api/v1/me/permissions stored in permissionStore.
 * Superadmins always get access.
 */
export function useCanAccess(resource: string, action = 'read'): boolean {
  return usePermissionStore((s) => s.hasPermission(resource, action))
}

export function useHasResource(resource: string): boolean {
  return usePermissionStore((s) => s.hasResource(resource))
}
